import React from 'react'
import { IconComment } from '@edulastic/icons'
import { EduIf } from '@edulastic/common'
import { sanitizeImgUrl } from '@edulastic/common/src/utils/html'
import {
  SectionTitle,
  SectionTotalItems,
  TestImage,
  TestInstruction,
  TestTitle,
} from '../styled-components'

const SectionsInfo = ({
  thumbnail = '',
  title = '',
  isRedirectedWithQuestionDelivery = false,
  totalItemsCountWithQuestionDelivery,
}) => {
  return (
    <>
      <TestImage>
        <img src={sanitizeImgUrl(thumbnail)} alt={title} />
      </TestImage>
      <TestTitle>{title}</TestTitle>
      <EduIf condition={isRedirectedWithQuestionDelivery}>
        <TestInstruction>
          <IconComment />
          <div style={{ marginLeft: 8 }}>
            <span>Teachers Instruction :</span> Reattempt few questions again.
          </div>
        </TestInstruction>
      </EduIf>
      <EduIf
        condition={
          isRedirectedWithQuestionDelivery &&
          typeof totalItemsCountWithQuestionDelivery === 'number'
        }
      >
        <SectionTotalItems>
          Reattempt {totalItemsCountWithQuestionDelivery} questions
        </SectionTotalItems>
      </EduIf>
      <SectionTitle>Your Test Sections</SectionTitle>
    </>
  )
}

export default SectionsInfo
